import { LinkedContextState } from '@context/LinkedItemZoneContext'
import { AnyID, Textures } from '@types'

export default function handlePasteAll(ctx: LinkedContextState, editZone) {
  if (!ctx.object.current) return
  const obj = ctx.object.current
  const id = obj.id as AnyID // TODO check? am dumb
  const currTexture = ctx.selectedTexture

  if (!currTexture) return
  const material = obj.zones[currTexture.zoneName].material
  obj.textures.forEach((property: Textures[number]) => {
    editZone(id, property.zoneName, material)
  })

  // ctx.setCopiedIconId(null)
  // const pasteIcons = ctx.pasteIcons
  // if (!pasteIcons) return
  // ctx.setPasteIcons(
  //   Object.fromEntries(Object.entries(pasteIcons).map(([key]) => [key, 'cantPaste'])),
  // )
  // TODO: may not be needed
  // ctx.setSelectedTexture((prev: Textures[number]) => {
  //   return {
  //     ...prev,
  //     searchID: currTexture.searchID,
  //     id: currTexture.id,
  //     name: currTexture.name,
  //     url: currTexture.url,
  //     groupID: currTexture.groupID,
  //   }
  // })
  // return ctx
}
